export const groupEventsByContext = (events) => {
  if (!Array.isArray(events)) {
    return {}
  }
  return events.reduce((groups, event) => {
    const contextId = event.contextId || 'default' // Fallback if no contextId
    if (!groups[contextId]) {
      groups[contextId] = []
    }
    groups[contextId].push(event)
    return groups
  }, {})
}

export function prepareBookedEventDataForListing(respData) {
  const bookedEventData = respData?.['booked-event-info']?.content
  const clinicData = respData?.['clinic-brand']
  const clinicLocationData = respData?.clinic
  const nextVisitBookedEvents = respData?.['nextVisitEvents']
  const patientData = respData?.PatientInfo

  return bookedEventData?.map((bookedEvent) => {
    const foundClinicBrandData = clinicData?.find(
      (clinic) => clinic?.id === bookedEvent?.clinicBrandId,
    )
    const foundClinicLocationData = clinicLocationData?.find(
      (clinicLocation) => clinicLocation?.id === bookedEvent?.clinicId,
    )
    const blockedNextVisitSlot = nextVisitBookedEvents?.find(
      (nextVisitEvent) => nextVisitEvent?.id === bookedEvent?.nextVisitReferenceBookedEventId,
    )

    const patientInfoData = patientData?.find((patient) => patient?.id === bookedEvent?.patientId)
    return {
      ...bookedEvent,
      clinicBrandData: foundClinicBrandData,
      clinicLocation: foundClinicLocationData,
      patientInfoData,
      blockedNextVisitSlot,
    }
  })
}
